export default {
  nameIsRequired: 'Name ist erforderlich',
  emailIsRequired: 'E-Mail ist erforderlich',
  passwordIsRequired: 'Passwort erforderlich',
  emailOrPhoneAreRequired: 'Einfügen einer E-Mail oder eines Telefons',
  onlyNumbers: 'Nur Zahlen sind im Telefonfeld zulässig',
  passwordMin8: 'Kennwort muss mindestens 8 Zeichen lang sein',
  habeasData: 'Sie müssen die Bedingungen akzeptieren',
  validEmail: 'Einfügen einer gültigen E-Mail',
  validPhone: 'Einfügen eines gültigen Telefons',
  codeIsRequired: 'Der gesendete Code ist erforderlich',
  newPasswordIsRequired: 'Neues Passwort erforderlich',
  confirmNewPassword: 'Sie müssen Ihr neues Passwort bestätigen',
  passwordsDontMatch: 'Kennwörter stimmen nicht überein',
  fillCorrectlyFormFields: 'Füllen Sie alle Formularfelder korrekt aus.'
}
